import React from 'react';
import Hero from '../components/Hero';

function Home() {
  const features = [
    {
      icon: '🏪',
      title: 'Point of Sale (POS)',
      description: 'Fast and efficient checkout system with real-time cart management, payment processing, and thermal receipt printing.'
    },
    {
      icon: '📦',
      title: 'Inventory Management',
      description: 'Track stock levels, manage products and categories, automated ingredient deduction with bill-of-materials support.'
    },
    {
      icon: '🚚',
      title: 'Supplier Management',
      description: 'Manage suppliers, track purchase orders, and maintain supplier relationships all in one place.'
    },
    {
      icon: '📊',
      title: 'Sales Analytics',
      description: 'Comprehensive dashboards with profit tracking, sales trends, and interactive charts for data-driven decisions.'
    },
    {
      icon: '🧾',
      title: 'VAT Compliance',
      description: 'Automatic 15% Saudi VAT calculation with ZATCA-compliant QR codes on all invoices and receipts.'
    },
    {
      icon: '👥',
      title: 'Multi-User Access',
      description: 'Role-based permissions for owners, supervisors, managers, cashiers, and employees with data isolation.'
    },
    {
      icon: '🖨️',
      title: 'Thermal Printing',
      description: 'WiFi integration with HZTZ thermal printers for professional Arabic and English receipt printing.'
    },
    {
      icon: '📱',
      title: 'Mobile & Tablet Ready',
      description: 'Optimized for all devices - works seamlessly on phones, tablets, and desktop computers.'
    },
    {
      icon: '🏢',
      title: 'Multi-Location Support',
      description: 'Manage multiple store locations from a single account with complete data isolation and security.'
    }
  ];

  return (
    <div>
      <Hero />
      
      <section className="features">
        <div className="features-container">
          <h2 className="section-title">Everything You Need to Run Your Business</h2>
          <p className="section-subtitle">
            Invex provides all the tools you need to manage your restaurant, cafe, grocery store, or retail business efficiently
          </p>
          
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="download" className="features" style={{ background: 'white' }}>
        <div className="features-container" style={{ textAlign: 'center' }}>
          <h2 className="section-title">Ready to Get Started?</h2>
          <p className="section-subtitle">
          </p>
          <div className="hero-buttons">
            <a href="#app-store" className="btn btn-primary">
              Download on App Store
            </a>
            <a href="#google-play" className="btn btn-primary">
              Get it on Google Play
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
